module.exports = __webpack_public_path__ + "img/Group 1504775757.7e6917e8.svg";